import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function assignTicket(payload) {
  try {
    const data = await authenticatedFetch(URL.assignTicketApi, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return data;
  } catch (error) {
    console.error("Error assigning ticket:", error);
    throw error;
  }
}
